import { Hidden } from '@leroy-merlin-br/backyard-react'

import { ContextVisibility } from 'shared/components/ContextVisibility'

import NavComponent, { NavProps } from './Nav'

export const Nav = (props: NavProps) => (
  <ContextVisibility when={['ecommerce', 'app']}>
    <Hidden when={['untilKilo', 'kilo']}>
      <NavComponent {...props} />
    </Hidden>
  </ContextVisibility>
)

export default Nav
